import React from 'react'
import { useTranslate } from 'react-translate'
import { CardSubtitle, CardText, CardTitle } from 'reactstrap'

const TermsCardContent = () => {
    let tc = useTranslate("terms-card")
    return (
        <>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">§1 Allgemeines, Leistungsumfang und Vertragspartner</CardTitle>
            <CardText className="text-wrap text-break text-dark paragraph">
                Die TelePraxen-Plattform ist ein Service- und Informationsportal für Patienten (Nutzer) und Ärzte. Über die Plattform können die Ärzte sich und ihre Leistungen in ihren „Online-Praxen“ im Web sowie in ihren „Offline-Praxen“ vor Ort präsentieren. On- und Offline-Praxen werden zur besseren Lesbarkeit als „Praxen“ und Nutzer, wo angezeigt, als „Patienten“ bezeichnet. Ärzte, die über keinen physischen Praxisstandort verfügen, sind auf der TelePraxen-Plattform nicht vertreten. So haben Patienten bei komplexeren Problemen die Gelegenheit, den Arzt auch persönlich zu konsultieren.
                <br />
                <br />
                Die TelePraxen erbringen selbst keine medizinischen Leistungen, sondern vermitteln Angebote von Arztpraxen an Patienten. Die TelePraxen erbringen im Auftrag der Praxen ausschließlich Plattformleistungen.
                <br />
                <br />
                Über die TelePraxen (<a className="btn-link text-success p-0 m-0" href="https://www.telepraxen.de/" target='_blank'>https://www.telepraxen.de/</a>) können Patienten Termine mit den Praxen vereinbaren und telediagnostische Untersuchungen (Telediagnostik/Ferndiagnostik) buchen. Für die Vereinbarung von Terminen in den Praxen und die Buchung, den Versand und die Rücksendung von Diagnostik-Kits gelten die AGB der TelePraxen.
                <br />
                <br />
                Wird die Terminbuchung mit einer anderen Person als dem Patienten (z. B. mit dem gesetzlichen Vertreter) geschlossen, gelten die Regelungen dieser AGB auch für diese Person. Die TelePraxen akzeptieren nur Nutzer, die älter als 18 Jahre sind. Minderjährige können über ihre gesetzlichen Vertreter (Erziehungsberechtigte) buchen. Der gesetzliche Vertreter schließt den Vertrag in deren Namen und bestätigt die erforderlichen Einwilligungen.
                <br />
                <br />
                Alle medizinischen Leistungen werden von der im Buchungsprozess angegebenen Praxis erbracht. Die medizinische Behandlung erfolgt stets durch den verantwortlichen Arzt. Vertragspartner für den Behandlungsvertrag über medizinische Leistungen sind der Patient und die behandelnde Praxis bzw. deren Ärzte. Für die Diagnostik und die Behandlungen gelten die AGB der Arztpraxen.
                <br />
                <br />
                Der Vertrag mit den TelePraxen über die Vermittlung bzw. Bereitstellung der Plattformleistungen kommt mit der Registrierung oder der Auftragsbestätigung der TelePraxen zustande, nachdem der Nutzer den Buchungsvorgang in den TelePraxen abgeschlossen und die geltenden AGB akzeptiert hat.
                <br />
                <br />
                Der Vertrag mit der Praxis, bzw. deren Ärzten über die Erbringung von medizinischen Leistungen kommt mit der Auftragsbestätigung der TelePraxen zustande, nachdem der Nutzer den Buchungsvorgang in den TelePraxen abgeschlossen und die geltenden AGB Arztpraxen akzeptiert hat.
                <br />
                <br />
                Die TelePraxenApp dient dem sicheren Datenaustausch innerhalb und zwischen Praxen, sowie zwischen Praxen und Patienten. Ergänzende Informationen zum Datenschutz finden Sie in unserer Datenschutzerklärung unter <a className="btn-link text-success p-0 m-0" href="https://telepraxen.de/datenschutz" target='_blank'>https://telepraxen.de/datenschutz</a> (Stand jeweils aktuell auf der Website).
                <br />
                <br />
                Zur besseren Lesbarkeit gelten personenbezogene Bezeichnungen für alle Geschlechter.
                <br />
                <br />
                Die TelePraxen sind ein Projekt der
                <br /><br />
                {tc("GENERAL-P3")}<br />
                {tc("GENERAL-P4")}<br />
                {tc("GENERAL-P5")}<br />
                {tc("GENERAL-P6")}<br />
                {tc("GENERAL-P7", { VAT: "DE 257 994 344" })}<br />
                <a className="btn-link text-success p-0 m-0" href="mailto:info@telepraxen.de">info@telepraxen.de</a>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">{tc("2-SCOPE-TITLE")}</CardTitle>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">{tc("SCOPE-SUBTITLE-1")}</CardSubtitle>
            <CardText>
                Die TelePraxen stellen die technische Buchungs-, Logistik- und Informationsplattform bereit und koordinieren im Auftrag des behandelnden Arztes die individuelle Zusammenstellung des DiagnostikKits sowie dessen Versand und Rücksendung.
                <br />
                <br />
                Telediagnostische Untersuchungen erfolgen auf ärztliche Anordnung der im Buchungsprozess ausgewählten Praxis über die TelePraxen. Durchführung, Auswertung und Abrechnung des Honorars der Untersuchung obliegen dem im Buchungsprozess genannten behandelnden Arzt, bzw. der genannten Praxis. Der Patient ist verpflichtet, bei Fragen wahrheitsgemäße Angaben zu machen und die Anleitung zu befolgen.
                <br />
                <br />
                Das Diagnostik-Kit wird an die vom Patienten im Buchungsprozess angegebene Lieferadresse versendet. Der Patient ist verpflichtet, die mit dem Kit gelieferten Anleitungen (TelePraxenKurzanleitung, Herstelleranleitung) zu befolgen und die Gegenstände bestimmungsgemäß zu behandeln.
                <br />
                <br />
                Die zur Durchführung der Untersuchung überlassenen Diagnostik-Kits gehen nicht in das Eigentum der Patienten über. Nach der Untersuchung sind sie ohne die nach einmaliger Anwendung verbrauchten Materialien zurückzugeben. Mit der Versandbestätigung erhält der Patient eine Checkliste, in der aufgeführt ist, welche Gegenstände zurückzusenden sind. Die Rücksendung ist im Versandkarton kostenfrei.
                <br />
                <br />
            </CardText>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Auftragsbestätigung
            </CardSubtitle>
            <CardText>
                Nach Abschluss der Buchung erhält der Patient eine Auftragsbestätigung. Diese enthält die folgenden Informationen:
                <br />
                <ul>
                    <li>
                        Typ der gebuchten telediagnostischen Untersuchung
                    </li>
                    <li>
                        Zahlungsbestätigung für die Anzahlung bei Buchung. Zusätzlich erhalten Sie eine Zahlungsbestätigung vom beauftragten Zahlungsdienstleister (PayPal, Kreditkartenunternehmen)
                    </li>
                    <li>
                        Höhe des Arzthonorars nach GOÄ (Gesamtbetrag)
                    </li>
                    <li>
                        Information über die Haftungshöchstgrenze bei Beschädigung oder Verlust des Diagnostik-Kits
                    </li>
                    <li>
                        Widerrufsbelehrung
                    </li>
                </ul>
            </CardText>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Versandbestätigung
            </CardSubtitle>
            <CardText>
                In der Regel wird das Diagnostik-Kit innerhalb von fünf Werktagen nach der Buchung zugestellt. Der Patient hat dafür zu sorgen, dass eine Zustellung innerhalb dieses Zeitraums möglich ist.
                <br /><br />
                Mit der Versandbestätigung werden dem Patienten die folgenden Informationen mitgeteilt:
                <br />
                <ul>
                    <li>
                        Trackingnummer des Paketdienstleisters
                    </li>
                    <li>
                        Typ der gebuchten telediagnostischen Untersuchung
                    </li>
                    <li>
                        Packliste des individuell zusammengestellten und personalisierten Diagnostik-Kits
                    </li>
                    <li>
                        Rückgabe-Stichtag (spätestes Datum für eine kostenlose Rücksendung)
                    </li>
                    <li>
                        Checkliste der zurückzusendenden Gegenstände
                    </li>
                    <li>
                        Widerrufsbelehrung
                    </li>
                </ul>
            </CardText>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Lieferschein, Beschädigung, Verlustmeldung
            </CardSubtitle>
            <CardText>
                Der Patient hat bei Erhalt des Pakets dieses auf Beschädigung und mit dem beigelegten Lieferschein auf Vollständigkeit des aus hygienischen Gründen versiegelten Inhalts zu prüfen.
                <br/><br/>
                Mit der Versandbestätigung werden dem Patienten die folgenden Informationen mitgeteilt:
            </CardText>
            <ul>
                <li>
                    Typ der gebuchten telediagnostischen Untersuchung
                </li>
                <li>
                    Packliste des individuell zusammengestellten und personalisierten Diagnostik-Kits
                </li>
                <li>
                    Rückgabe-Stichtag (spätestes Datum für eine kostenlose Rücksendung)
                </li>
                <li>
                    Checkliste der zurückzusendenden Gegenstände
                </li>
                <li>
                    Widerrufsbelehrung
                </li>
            </ul>
            <CardText>
                Beschädigungen des Versandkartons oder eine fehlende Zustellung sind unverzüglich sowohl dem Paketdienst als auch der CAPITAL HEALTH Hospital Group GmbH zu melden.
                <br /><br />
                Das Gleiche gilt für selbst verursachte Beschädigungen des Diagnostik-Kits sowie Teilverluste oder Verluste nach Zustellung.
                <br />
                <br />
                Die Meldung ist zu richten an:
                <br /><br />
                {tc("GENERAL-P3")}<br />
                {tc("GENERAL-P4")}<br />
                <a className="btn-link text-success p-0 m-0" href="mailto:info@telepraxen.de">info@telepraxen.de</a>
            </CardText>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Rücksendung zum im Lieferschein angegebenen Datum
            </CardSubtitle>
            <CardText>
                Nach der Messung ist das Kit gemäß der Checkliste mit dem beiliegenden Rücksendeetikett an die in der Auftragsbestätigung angegebene Rücksendeadresse zu senden.
                <br/><br/>
                Der Patient trägt das Risiko für eine ordnungsgemäße Verpackung und fristgerechte Übergabe an den Versanddienstleister, soweit nicht zwingendes Verbraucherrecht entgegensteht.
                <br/><br/>
                Das Diagnostik-Kit muss spätestens zum im Lieferschein angegebenen Datum zurückgesendet werden. Als Rückgabestichtag gilt das Datum der Annahme durch den Versanddienstleister. Eine spätere Rücksendung führt zu Verzug mit kostenpflichtigen Folgen (siehe AGB Arztpraxen, Verzugsschaden, Schadenshöhe, Haftungshöchstgrenze).
            </CardText>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Entsorgung
            </CardSubtitle>
            <CardText>
                Hinweise zur Entsorgung von verbrauchten Materialien, beispielsweise Sensoren, finden Sie in den Herstellerunterlagen.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 3 Widerruf
            </CardTitle>
            <CardText>
                Wenn über die TelePraxen online ein Arzttermin oder eine telediagnostische Untersuchung vereinbart wird, ohne dass zum Zeitpunkt der Buchung eine Anzahlung getätigt wird, besteht kein gesetzliches Widerrufsrecht. Eine kostenfreie Stornierung des Termins ist nur bei rechtzeitiger Absage möglich (siehe AGB Arztpraxen, Terminabsage und Ausfallsgebühr).
                <br/><br/>
                Wenn über die TelePraxen online ein Arzttermin oder eine telediagnostische Untersuchung vereinbart und eine Anzahlung getätigt wird, steht dem Patienten grundsätzlich ein Widerrufsrecht zu. Dieses kann jedoch eingeschränkt sein oder erlöschen, insbesondere wenn der Patient einer medizinischen Dienstleistung vor Ablauf der Widerrufsfrist ausdrücklich zugestimmt hat und seine Kenntnis vom Erlöschen des Widerrufsrechts bestätigt hat, nachdem die Dienstleistung vollständig erbracht wurde.
                <br/><br/>
                Mit der Buchung einer telediagnostischen Untersuchung erklärt sich der Patient damit einverstanden, dass er seinen Auftrag nur innerhalb von 14 Tagen nach Erhalt des Pakets mit dem Diagnostik-Kit kostenlos widerrufen kann, sofern das Kit unversehrt und versiegelt zurückgesendet wird. Erstattungen der Anzahlung erfolgen über denselben Zahlungsweg. Die Stornierung kann über den entsprechenden Button erfolgen.
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 4 Übermittlung der Untersuchungsergebnisse
            </CardTitle>
            <CardText>
                Die Ergebnisse der Untersuchung werden zunächst ohne Auswertung durch Arzt über die TelePraxen-App mitgeteilt. Die Zustellung des Arztbefundes erfolgt separat.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 5 Kosten (allgemein)
            </CardTitle>
            <CardText>
                Die Leistungen der TelePraxen werden vom Arzt beauftragt. Für die Leistungen der TelePraxen fallen für den Patienten keine Kosten an.
                <br/><br/>
                Die im Buchungsprozess ausgewiesenen Preise verstehen sich, sofern nicht anders angegeben, in Euro. Heilbehandlungen im Bereich der Humanmedizin sind in der Regel umsatzsteuerfrei.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 6 Registrierung - Kontolöschung
            </CardTitle>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Registrierung
            </CardSubtitle>
            <CardText>
                Telediagnostische Untersuchungen sind nur über ein registriertes Konto möglich. Deshalb ist die Einrichtung eines TelePraxen-Nutzerkontos erforderlich.
                <br/><br/>
                Über das Konto werden unter anderem die Auftragsbestätigung, die Mitteilung nach Versand und die elektronische Widerrufsfunktion bereitgestellt.
                <br/><br/>
            </CardText>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Kontolöschung
            </CardSubtitle>
            <CardText>
                Registrierte Patienten, bzw. Nutzer, können jederzeit die Löschung ihres Kontos durchführen. Hierzu loggen sie sich ein und führen unter „Kontolöschung“ die endgültige Löschung ihres Kontos durch.
                <br/><br/>
                <strong>ACHTUNG: Sichern Sie vor der Löschung ihre Daten. Die Daten können nicht mehr wiederhergestellt werden!</strong>
                <br/><br/>
                Die TelePraxen können Patienten, bzw. Nutzer, von den Leistungen der Plattform ausschließen, wenn
            </CardText>
            <ul>
                <li>
                    der Patient und/oder Nutzer das Portal der TelePraxen nicht sachgerecht nutzt
                </li>
                <li>
                    Benutzernamen und Passwort nicht geheim hält oder Dritten zugänglich macht oder deren Kenntnisnahme ermöglicht oder duldet.
                </li>
            </ul>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 7 Datenschutz und Datensicherung
            </CardTitle>
            <CardText>
                Für die Verarbeitung personen- und gesundheitsbezogener Daten gelten unsere Datenschutzhinweise. Gesundheitsdaten werden nur im Rahmen der vereinbarten Leistung und der gesetzlichen Vorgaben verarbeitet.
                <br/><br/>
                Wir übernehmen keine allgemeine Datensicherungsgarantie für die von Ihnen übermittelten Daten. Wir empfehlen in regelmäßigen Abständen Backups Ihrer Daten zu erstellen.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 8 Qualitätssicherung
            </CardTitle>
            <CardText>
                Zur Qualitätssicherung der TelePraxen werden Patienten, bzw. Nutzer, stichprobenweise befragt. Die Teilnahme ist freiwillig und vertraulich. Konkrete Beschwerden richten Sie bitte an die E-Mail-Adresse <a className="btn-link text-success p-0 m-0" href="mailto:beschwerde@telepraxen.de">beschwerde@telepraxen.de</a>.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 9 Leistungsabgrenzung, Haftung TelePraxen
            </CardTitle>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Leistungsabgrenzung
            </CardSubtitle>
            <CardText>
                Die TelePraxen erbringen Vermittlungs-, Buchungs- und Logistikleistungen. Für medizinische Leistungen (Diagnose, Therapie, Auswertung, GOÄ-Abrechnung) haftet ausschließlich die behandelnde Praxis als Leistungserbringerin. Die TelePraxen haften nicht für ärztliche Fehlentscheidungen oder Behandlungsergebnisse.
                <br/><br/>
            </CardText>
            <CardSubtitle tag="h5" className="text-success mb-2 fw-bolder">
                Haftung
            </CardSubtitle>
            <CardText>
                Die Haftungsbeschränkungen dieser AGB gelten nur für die Plattform- und Logistikleistungen der TelePraxen. Gesetzliche Haftungsansprüche, insbesondere bei Vorsatz, grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit, bleiben unberührt und können in AGB's nicht ausgeschlossen werden, sofern die TelePraxen für den Schaden verantwortlich sind.
                <br/><br/>
                Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) im Rahmen der Plattform- und Logistikleistungen ist die Haftung der TelePraxen auf den vorhersehbaren, vertragstypischen Schaden begrenzt.
                <br/><br/>
                Im Übrigen ist die Haftung der TelePraxen für Plattform- und Logistikleistungen, soweit gesetzlich zulässig, ausgeschlossen.
                <br/><br/>
                Die vorstehenden Haftungsbeschränkungen gelten entsprechend zugunsten der gesetzlichen Vertreter und Erfüllungsgehilfen der TelePraxen.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 10 Streitbeilegung
            </CardTitle>
            <CardText>
                Informationen zu Verbraucherrechten und außergerichtlicher Streitbeilegung in Deutschland finden Sie auf der Website der Verbraucherzentrale (Verbraucherzentrale Bundesverband).
                <br/><br/>
                Wir sind weder verpflichtet noch grundsätzlich bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                <br/><br/>
                Ob für die behandelnde Praxis gesonderte berufs- oder kammerrechtliche Schlichtungswege bestehen, teilt Ihnen die Praxis auf Anfrage mit.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                § 11 Änderungen
            </CardTitle>
             <CardText>
                Die TelePraxen können diese Allgemeinen Geschäftsbedingungen mit Wirkung für die Zukunft ändern. Änderungen für bestehende Vertragsverhältnisse (registrierte Nutzer mit laufendem Zugang) werden mindestens vier Wochen vor Inkrafttreten per E-Mail oder durch einen deutlich sichtbaren Hinweis auf <a className="btn-link text-success p-0 m-0" href="https://www.telepraxen.de/" target='_blank'>https://www.telepraxen.de/</a> mitgeteilt.
                <br/><br/>
                Widerspricht der Nutzer den Änderungen nicht innerhalb von vier Wochen nach Zugang der Mitteilung, gelten die geänderten AGB als angenommen. Hierauf wird in der Mitteilung hingewiesen. Widerspricht der Nutzer, kann TelePraxen das Vertragsverhältnis zum Zeitpunkt des Inkrafttretens der Änderung kündigen.
                <br/><br/>
                Für Einzelbuchungen (z. B. Telediagnostik) gelten die zum Zeitpunkt der Buchungsbestätigung gültigen AGB.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                §12 Salvatorische Klausel
            </CardTitle>
             <CardText>
                Sollte eine Bestimmung dieser AGB ganz oder teilweise unwirksam oder undurchführbar sein oder werden oder eine Lücke enthalten, bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt. Anstelle der unwirksamen oder undurchführbaren Bestimmung bzw. zur Ausfüllung der Lücke treten die jeweiligen gesetzlichen Regelungen.
                <br/><br/>
            </CardText>
            <CardTitle tag="h3" className="d-flex justify-content-center text-info text-center">
                §13 Schlussbestimmungen
            </CardTitle>
             <CardText>
                Es gilt deutsches Recht.
                <br/><br/>
                Gerichtsstand: Ist der Patient oder Nutzer Verbraucher, gelten die gesetzlichen Gerichtsstände. Der Nutzer kann Klage auch an seinem Wohnsitz erheben. Ist der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für Streitigkeiten aus dem Vertragsverhältnis Berlin, Deutschland.
                <br/><br/>
                Gültig ab 15.07.2026
            </CardText>
        </>
    )
}

export default TermsCardContent;